import { FC } from 'react';

import { useFormikContext } from 'formik';
import { useGetProfile } from 'modules/account/settings/hooks';
import { CalendarCheckIcon } from 'ui/components/icon';
import { Dropdown } from 'ui/components/nav';
import { cn } from 'utils/helpers';

import { EVENT_FORM } from '../schema';

const notifyOptions = [
  { label: '5 Mins', value: 5 },
  { label: '10 Mins', value: 10 },
  { label: '15 Mins', value: 15 },
  { label: '30 Mins', value: 30 },
  { label: '1 Hr', value: 60 },
];

const Creator: FC = () => {
  const { data: profile } = useGetProfile();
  const { values, setFieldValue } = useFormikContext<EVENT_FORM>();

  return (
    <div className="flex items-center py-3">
      <CalendarCheckIcon className="mr-4 h-5 w-5 text-content" />
      <div className="flex-1">
        <p className="text-sm">{profile?.fullName}</p>
        <div className="text-xs text-content flex items-center gap-1">
          Notify{' '}
          <Dropdown
            defaultValue={values.notifyBefore}
            placeholder="--:--"
            options={notifyOptions}
            onChange={(val) => setFieldValue('notifyBefore', val.value)}
            selectedClassName={cn(
              'w-fit p-0',
              'bg-transparent justify-center h-5',
            )}
            customIcon={<div />}
            optionsClassName="max-h-[200px] max-w-[100px]"
            className="h-5"
          />
          before
        </div>
      </div>
    </div>
  );
};

export default Creator;
